import { render, staticRenderFns } from "./SmartGrowth.vue?vue&type=template&id=a1993c62&scoped=true&"
import script from "./SmartGrowth.vue?vue&type=script&lang=js&"
export * from "./SmartGrowth.vue?vue&type=script&lang=js&"
import style0 from "./SmartGrowth.vue?vue&type=style&index=0&id=a1993c62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1993c62",
  null
  
)

export default component.exports